import { Box, CircularProgress, IconButton } from '@material-ui/core';
import { Mixpanel } from '../mixpanel';
import { RegularSizeValue, SizeType } from 'common-ts/dist/models/Cart';
import { BodyMeasCompleteForClothingType, BodyMeasurementDetailList, BodyMeasurements, BodyMeasurementsKey, CalculateClothBodyMeasurementsFromBodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingMeasurementsKey, ClothingType, CompleteBodyMeasurements, CoreBodyMeasurements, CreateBodyContructRangeForKey2, ExtractBodyMeasurementsFromClothBodyMeasurements, FitType, RoundClothingMeasurementsToHalfPoint, UserBodyMeasurements, getFitFamily } from 'common-ts/dist/models/UserMeasurements';
import { fetchUserMeasurementEstimatesBody, inputBodyMeasurementsForm, postBodyMeasurement } from '../redux/MeasurementsRedux';
import { closeOverlayAndResetWithCleanup } from '../redux/UIOverlayUniversalSizeRedux';
import { useAppDispatch } from '../reduxhooks';
import { openOverlayCreateMeasWithInitialization } from '../redux/UIOverlayMeasurementMethodSelectionViewRedux';
import PersonalSizeBenefitStart from './OverlayViewUniversalSize0BenefitStart';
import PersonalSizeBenefitMini from './OverlayViewUniversalSize0BenefitMini';
import PersonalSizeMethodIntro from './OverlayViewUniversalSize0MethodIntro';
import PersonalSizeSizeSelect from './OverlayViewUniversalSize1SizeSelect';
import PersonalSizeSizeAdjust from './OverlayViewUniversalSize2SizeAdjust';
import PersonalSizeResultLoading from './OverlayViewUniversalSize3ResultLoading';
import PersonalSizeCheckAdjustSize from './OverlayViewUniversalSize5CheckSize';
import PersonalSizeResult from './OverlayViewUniversalSize4Result';
import { sendWebsiteEventMessage } from '../telegrambotevents';
import { UniversalSizeActiveScreen } from '../redux/UIOverlayUniversalSizeRedux';
import { closeOverlayAndReset as closeOverlayAndResetUnivSizeCreateView, setValues as setValuesUnivSizeCreateView, openOverlay as openOverlayUnivSizeCreateView } from '../redux/UIOverlayUniversalSizeCreateMeasRedux';
import React from 'react';
import PersonalSizeUkurTiapBagianV2 from './OverlayViewUniversalSizeCreateMeas1UkurTiapBagian';
import ProductOnUser from 'common-ts/dist/models/Product';
import { openOverlayHowTo } from '../redux/UIOverlayPersonalSizeRedux';
import OverlayViewFlowComponentAccount from './OverlayViewFlowComponentAccount';
import { ArrowBack } from '@material-ui/icons';
import OverlayViewPersonalFitModifySize from './OverlayViewPersonalSizeDetail2Edit';

import axios, { AxiosRequestConfig } from 'axios';

// Determines which flow is used based on starting parameters
export interface FlowSelectionData {
  isSignedIn: boolean
}

// State data for flow
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateData {
  currentScreen: UniversalSizeActiveScreen
  titleNumber: number
  currentUserBodyMeasurements: UserBodyMeasurements
  userSub: string
  currentFlowData: any
  productDetail: ProductOnUser | undefined,
  flowVariant: string,
  flowInputVariables: any,
}

// Callback to change state data for flow. 
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateCallback {
  delayedDispatch: (currentScreen: UniversalSizeActiveScreen) => void
  setTitleNumber: (titleNumber: number) => void
  setCurrentFlowData: (updatedCurrentFlowData: any) => void
}

//
// RENDERER 
// Master function that is used to select and pass data to the block 
// selected using the flow selection data.
//
export function FlowComponentMaster(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  
  let children: JSX.Element[] = [];
  children = FlowComponentMensTops(flowSelectionData, flowStateData, flowStateCallback);
  
  // We choose the right block to use with the flow selection data.
  return (
    <Box>
      {
        children
      }
    </Box>
  );
}

function FlowComponentMensTops(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  const dispatch = useAppDispatch();

  let titleNumber = -1;

  let delayedDispatch = flowStateCallback.delayedDispatch;

  let children: JSX.Element[] = [];

  switch (flowStateData.currentScreen) {
    case UniversalSizeActiveScreen.BenefitStart:
      children.push(<PersonalSizeBenefitMini
        handleBack={() => { // DOESN'T SUPPORT BACK / CLOSE. WHAT FOR?
        }}
        handleNext={() => {
          delayedDispatch(UniversalSizeActiveScreen.SizeSelect);
          sendWebsiteEventMessage("[PERSONAL FIT] 00. MINI BENEFIT start - COMPLETE");
        }}/>
      );
      break;
    case UniversalSizeActiveScreen.SizeSelect:
      titleNumber = 1;
      children.push(<PersonalSizeSizeSelect
        flowVariant={flowStateData.flowVariant}
        flowInputVariables={flowStateData.flowInputVariables}
        handleBack={() => {
          dispatch(closeOverlayAndResetWithCleanup());

          // IF USER CLOSES, WE OPEN REGULAR SIZE SELECTION / CREATION INTERFACE
          // if (flowStateData.flowVariant === "productDetailInstant") {
          //   dispatch(openOverlayCreateMeasWithInitialization({
          //     clothingType: flowStateData.productDetail?.clothingType as any,
          //     fitType: flowStateData.productDetail?.defaultFitType as any,
          //     productDetail: flowStateData.productDetail,
          //     addToCartAfterCreation: true,
          //   }));
          // }
          sendWebsiteEventMessage("[PERSONAL FIT] 01. Ukuran pilih - BACK & CLOSE");
        }}
        handleNext={(updatedCurrentFlowData: any) => {
          let config: AxiosRequestConfig = { }
    
          config = {
            method: 'post',
            url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability/meas-serviceable',
            data: JSON.stringify(
              {
                isFastServiceabilityCheck: true,
                measurements: updatedCurrentFlowData.clothMeasValue,
                constructRules: CreateBodyContructRangeForKey2(
                  updatedCurrentFlowData.clothingType as any,
                  updatedCurrentFlowData.fitType as any,
                )
              })
          };

          axios(config).then((response) => {
            if (response?.data?.additionalRequestResultData?.requireAdjustments === false) {
              setTimeout(() => {
                delayedDispatch(UniversalSizeActiveScreen.SizeAdjust); // Directly to size adjust
              }, 200);
            } else {
              const adjustAutomatically = true;
                // flowStateData.flowInputVariables?.clothMeasSuggestion || 
                // flowStateData.flowInputVariables?.clothMeasSuggestionOrderIdItemNumber || 
                // flowStateData.flowInputVariables?.clothMeasValue ? true : false;
              if (adjustAutomatically) {
                // OPTION 1 (FASTER, CONFUSION RISK): ADJUST AUTOMATICALLY / ALL THE WAY
                flowStateCallback.setCurrentFlowData((currentObj: any) => ({
                  ...currentObj,
                  clothMeasValue: {
                    ...currentObj.clothMeasValue,
                    ...response.data.additionalRequestResultData.modAdjustments, // ADJUST RIGHT AWAY
                  },
                  neededModAdjustments: undefined,
                }));
                delayedDispatch(UniversalSizeActiveScreen.SizeAdjust);

              } else {
                // OPTION 2 (MORE PERMISSION, SLOWER, RISKIER): MAKE ADJUSTMENT PERMISSION
                flowStateCallback.setCurrentFlowData((currentObj: any) => ({
                  ...currentObj,
                  neededModAdjustments: response.data.additionalRequestResultData.modAdjustments
                }));
                setTimeout(() => {
                  delayedDispatch(UniversalSizeActiveScreen.SizeSelectServiceabilityAdjust); // Need confirmation
                }, 200);
              }
            }
          });

          delayedDispatch(UniversalSizeActiveScreen.SizeSelectServiceabilityLoading);
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            clothingType: updatedCurrentFlowData.clothingType,
            fitType: updatedCurrentFlowData.fitType,
            clothMeasValue: updatedCurrentFlowData.clothMeasValue,
          });
          sendWebsiteEventMessage("[PERSONAL FIT] 01. Ukuran pilih - COMPLETE");
        }}
      />);
      break;
    case UniversalSizeActiveScreen.SizeSelectServiceabilityLoading:
      titleNumber = 2;
      children.push(<Box style={{width: '100%', minHeight: '400px', 
      display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <CircularProgress />
        </Box>)
      break;
    case UniversalSizeActiveScreen.SizeSelectServiceabilityAdjust:
      titleNumber = 2;
      children.push(<PersonalSizeCheckAdjustSize
        clothingType={flowStateData.currentFlowData.clothingType as any}
        fitType={flowStateData.currentFlowData.fitType as any}
        isBody={true}
        currentMeasurements={flowStateData.currentFlowData.clothMeasValue as any}
        adjustedMeasurements={{
          ...flowStateData.currentFlowData.clothMeasValue,
          ...flowStateData.currentFlowData.neededModAdjustments
        }}
        onBack={() => {
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            neededModAdjustments: undefined,
          });
          delayedDispatch(UniversalSizeActiveScreen.SizeSelect);
        }}
        onOk={() => {
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            clothMeasValue: {
              ...flowStateData.currentFlowData.clothMeasValue,
              ...flowStateData.currentFlowData.neededModAdjustments
            },
            neededModAdjustments: undefined,
          });
          delayedDispatch(UniversalSizeActiveScreen.SizeAdjust);
        }}
      />);
      break;
    case UniversalSizeActiveScreen.SizeAdjust:
      titleNumber = 2;
      children.push(<PersonalSizeSizeAdjust
        flowVariant={flowStateData.flowVariant}
        flowInputVariables={flowStateData.flowInputVariables}
        currentFlowData={flowStateData.currentFlowData}
        handleBack={() => {
          delayedDispatch(UniversalSizeActiveScreen.SizeSelect);
          sendWebsiteEventMessage("[PERSONAL FIT] 02. Ukuran adjust - BACK");
        }}
        handleNext={(updatedCurrentFlowData: any) => {
          delayedDispatch(UniversalSizeActiveScreen.BenefitMiddle);
          flowStateCallback.setCurrentFlowData({
            ...flowStateData.currentFlowData,
            ...updatedCurrentFlowData,
            bodyMeasValue: ExtractBodyMeasurementsFromClothBodyMeasurements(updatedCurrentFlowData.clothMeasValue)
          });
          sendWebsiteEventMessage("[PERSONAL FIT] 02. Ukuran adjust - COMPLETE");
        }}
      />);
      break;
    case UniversalSizeActiveScreen.BenefitMiddle:
        children.push(<PersonalSizeBenefitStart
          handleBack={() => { // DOESN'T SUPPORT BACK / CLOSE. WHAT FOR?
          }}
          handleNext={() => {
            delayedDispatch(UniversalSizeActiveScreen.ResultLoading);
            sendWebsiteEventMessage("[PERSONAL FIT] 00. Benefit start - COMPLETE");
          }}
        />);
        break;
    case UniversalSizeActiveScreen.ResultLoading:
      children.push(<PersonalSizeResultLoading
        currentFlowData={flowStateData.currentFlowData}
        onFetchMeasEstimateSuccess={() => {
          delayedDispatch(UniversalSizeActiveScreen.Result);
          sendWebsiteEventMessage("[PERSONAL FIT] 03. Result loading - COMPLETE");
        }}/>);
      break;
    case UniversalSizeActiveScreen.Result:
      const triggerList: {[key: string]: {
        clothingMeasurementsKey: string // Same as the key for this dictionary
        bodyMeasurementsKey: string,
        triggerText: string
        triggerCallback: () => void
        showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
      }} = {};
      if (!flowStateData.currentFlowData.bodyMeasValue?.[BodyMeasurementsKey.panjangLenganPanjang]) {
        if (flowStateData.flowVariant === 'advanced') {
          triggerList[ClothingMeasurementsKey.panjangLenganPanjang as string] = {
            clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPanjang as string,
            bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPanjang as string,
            triggerText: "ATUR",
            triggerCallback: () => {
              delayedDispatch(UniversalSizeActiveScreen.EditFull);
              sendWebsiteEventMessage("[PERSONAL FIT] 01. Result shown - ATUR panjangLenganPanjang");
            }
          }
        } else {
          triggerList[ClothingMeasurementsKey.panjangLenganPanjang as string] = {
            clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPanjang as string,
            bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPanjang as string,
            triggerText: "ATUR",
            triggerCallback: () => {
              delayedDispatch(UniversalSizeActiveScreen.LengkapiUkuran);
              sendWebsiteEventMessage("[PERSONAL FIT] 01. Result shown - LENGKAPI panjangLenganPanjang");
            }
          }
        }
      }
      if (flowStateData.flowVariant === 'advanced') {
        triggerList[ClothingMeasurementsKey.panjangLenganPendek as string] = {
          clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPendek as string,
          bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPendek as string,
          triggerText: "ATUR",
          triggerCallback: () => {
            delayedDispatch(UniversalSizeActiveScreen.EditFull);
            sendWebsiteEventMessage("[PERSONAL FIT] 01. Result shown - ATUR panjangLenganPendek");
          },
          showMeasurementAs: flowStateData.currentFlowData.bodyMeasValue?.[BodyMeasurementsKey.panjangLenganPendek] ? 'NUMBER' : undefined,
        }
        triggerList[ClothingMeasurementsKey.lebarLenganBaju as string] = {
          clothingMeasurementsKey: ClothingMeasurementsKey.lebarLenganBaju as string,
          bodyMeasurementsKey: BodyMeasurementsKey.lingkarLenganBisep as string,
          triggerText: "ATUR",
          triggerCallback: () => {
            delayedDispatch(UniversalSizeActiveScreen.EditFull);
            sendWebsiteEventMessage("[PERSONAL FIT] 01. Result shown - ATUR lebarLenganPendek");
          },
          showMeasurementAs: flowStateData.currentFlowData.bodyMeasValue?.[BodyMeasurementsKey.lebarLenganPendek] ? 'NUMBER' : undefined,
        }
      }
    children.push(<PersonalSizeResult
      name={flowStateData.currentUserBodyMeasurements?.nama ? flowStateData.currentUserBodyMeasurements.nama : 'User'}
      bodyMeasurements={flowStateData.currentFlowData?.bodyMeasValue ?? {}}
      firstClothingType={flowStateData.currentFlowData?.clothingType ?? ClothingType.Kaos}
      firstFitType={flowStateData.currentFlowData?.fitType ?? FitType.SlimFit}
      buttonTextType={'result-create'}
      handleBack={() => {
        delayedDispatch(UniversalSizeActiveScreen.SizeSelect);
        sendWebsiteEventMessage("[PERSONAL FIT] 03. Result shown - BACK");
      }}
      handleUbahUkuran={() => {
        if (flowStateData.flowVariant === 'advanced') {
          delayedDispatch(UniversalSizeActiveScreen.EditFull);
          sendWebsiteEventMessage("[PERSONAL FIT] 01. Result shown - ATUR ukuran full");
          return;
        }

        delayedDispatch(UniversalSizeActiveScreen.SizeSelect);
        sendWebsiteEventMessage("[PERSONAL FIT] 03. Result shown - BACK");
      }}
      handleSubmit={() => {   
        const userMeasurements: UserBodyMeasurements = {
          "adjustedMeasurements": flowStateData.currentFlowData.bodyMeasValue,
          "bodyOrClothingMeasurements": "BODY",
          "bodyType": "rectangle",
          "creationMethod": "online-body",
          // Set explicitly: the draft is merged (Object.assign), so without this a
          // leftover fitType from an earlier edit in the same session would survive.
          "fitType": flowStateData.productDetail?.clothingType ?
            getFitFamily(flowStateData.productDetail.clothingType as ClothingType, flowStateData.productDetail.defaultFitType as FitType) :
            'STANDARD',
          "generatedMeasurements": {
          },
          "generatedMeasurementsRange": {
          },
          "generatedMeasurementsSafe": {
          },
          "height": 175,
          "sizeType": SizeType.personal,
          "userSelfInputMeasurements": {
          },
          "weight": 75
        };
        dispatch(inputBodyMeasurementsForm(userMeasurements));

        if (flowStateData.flowVariant === 'measKitScanMarketplace') {
          delayedDispatch(UniversalSizeActiveScreen.CheckSignedIn);
        } else {
          dispatch(postBodyMeasurement(flowStateData.productDetail?.clothingType ? {
            clothingType: flowStateData.productDetail?.clothingType as ClothingType,
            fitType: flowStateData.productDetail?.defaultFitType as FitType,
            productDetail: flowStateData.productDetail,
          } : ''));
  
          dispatch(closeOverlayAndResetWithCleanup());
          dispatch(openOverlayHowTo());
        }
      }}
      triggerList={triggerList}
    />);
      break;
    case UniversalSizeActiveScreen.EditFull:
      titleNumber = -1;
      const usedMeas = flowStateData.currentFlowData?.bodyMeasValue ?? {};
      children.push(
      <Box style={{margin: '21px'}}>
        <Box
          style={{
            position: 'absolute',
            top: '12px',
            left: '12px',
            borderRadius: '50%',
            padding: '6px',
          }}
          onClick={() => {
            delayedDispatch(UniversalSizeActiveScreen.Result);
            sendWebsiteEventMessage("[PERSONAL FIT EDIT] 01. Edit screen - BACK");
          }}
        >
          <IconButton style={{
            padding: '0',
            color: 'black',
          }}>
            <ArrowBack />
          </IconButton>
        </Box>
        <OverlayViewPersonalFitModifySize
          startingClothingBodyMeasurements={ // B-complete, CB-optional
            CompleteBodyMeasurements(usedMeas, 
              RegularSizeValue.L)}
          startingClothingBodyMeasurementsCBComplete={ // CB-complete
            CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L, [])}
          startingClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
            RoundClothingMeasurementsToHalfPoint(
            CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L))}
          startingRawClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
            CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
              FitType.RegularFit, 
              usedMeas, 
              RegularSizeValue.L)}
          handleSubmit={(value, valueClothing, lastUpdatedMeasurementsList) => {

            flowStateCallback.setCurrentFlowData({
              ...flowStateData.currentFlowData,
              bodyMeasValue: value
            });

            delayedDispatch(UniversalSizeActiveScreen.Result);
          }}
          isMinimized={false}
        />
      </Box>);
      break;
    case UniversalSizeActiveScreen.LengkapiUkuran: // Only used for panjang lengan panjang
    let plpLimits = [40, 60, 68];

    const leherValue = flowStateData.currentFlowData.bodyMeasValue?.[BodyMeasurementsKey.lingkarLeher] ?? 0;

    // TODO Manually written here for fast response. Written down from user body meas.
    if (leherValue <= 37) {
      plpLimits = [40, 60, 68];
    } else if (leherValue <= 41) {
      plpLimits = [40, 62, 69];
    } else if (leherValue <= 45) {
      plpLimits = [40, 64, 70];
    }

      children.push(
        <Box style={{margin: '60px 20px 10px'}}>
      <PersonalSizeUkurTiapBagianV2
    issues={['panjangLenganPanjang']}
    issuesLimits={{'panjangLenganPanjang': plpLimits}}
    clothingType={ClothingType.KemejaPanjang}
    fitType={FitType.RegularFit}
    userSelfInputMeasurements={{}}
    generatedMeasurements={{}}
    generatedMeasurementsRange={{}}
    generatedMeasurementsSafe={{}}
    handleBack={() => {
      delayedDispatch(UniversalSizeActiveScreen.Result);
      sendWebsiteEventMessage("[PERSONAL FIT EDIT] 01. Lengkapi ukuran screen - BACK");
    }}
    handleEachBack={(issues, newIssueIndex) => {
    }}
    handleEachSubmit={(issues, newIssueIndex, currentValue) => {
      flowStateCallback.setCurrentFlowData({
        ...flowStateData.currentFlowData,
        bodyMeasValue: {
          ...flowStateData.currentFlowData.bodyMeasValue,
          'panjangLenganPanjang': currentValue
        }
      });
    }}
    handleFinish={() => {
      delayedDispatch(UniversalSizeActiveScreen.Result);
    }}/>
    </Box>);
      break;
    case UniversalSizeActiveScreen.CheckSignedIn:
      children.push(<OverlayViewFlowComponentAccount
        handleOnSignedIn={() => {
          dispatch(postBodyMeasurement(flowStateData.productDetail?.clothingType ? {
            clothingType: flowStateData.productDetail?.clothingType as ClothingType,
            fitType: flowStateData.productDetail?.defaultFitType as FitType,
            productDetail: flowStateData.productDetail,
          } : ''));
  
          dispatch(closeOverlayAndResetWithCleanup());
          dispatch(openOverlayHowTo());
        }} />);
      break;
  }

  if (flowStateData.titleNumber !== titleNumber) {
    flowStateCallback.setTitleNumber(titleNumber);
  }

  return children;
}